<template>
    <div>
    <form class="mb-4" v-if="withSubmit" @submit.prevent="applyFilters">
        <div class="grid grid-cols-3 items-start">
            <input
                v-if="searchOptions.includes('text')"
                class="rounded-lg flex"
                type="text"
                placeholder="Search Text"
                v-model="filters.search_text"
                v-on:keyup.enter="applyFilters"
            />
            <t-select
                v-if="searchOptions.includes('location')"
                class="flex bg-white text-gray-800 mx-auto rounded-lg w-fit lg:block hidden border-salesium-blue h-fit"
                placeholder="Distance"
                :options="radiusChoices"
                textAttribute="name"
                valueAttribute="id"
                v-model="filters.selectedRadius"
            ></t-select>

            <input
                v-if="searchOptions.includes('location')"
                class="w-fit rounded-lg"
                type="text"
                placeholder="nearby zip"
                v-model="filters.postal_code"
                @change="updatePostalCode"
            />
        </div>
        <div class="relative flex flex-row flex-wrap grid grid-cols-3 gap-4 z-10 px-2 items-center justify-center mt-4 sm:inset-0 w-fit rounded-full justify-start">
            <span class="flex">
                Industry:
                <t-select
                    v-if="searchOptions.includes('industry')"
                    class="ml-4 bg-white text-gray-800 mx-auto rounded-lg lg:block hidden border-salesium-blue w-fit"
                    :options="industriesData"
                    textAttribute="name"
                    valueAttribute="id"
                    v-model="filters.selectedIndustry"
                    @change="selectIndustry"
                ></t-select>
            </span>
            <span v-if="searchOptions.includes('profession')" class="flex">
                Profession:
                <t-select
                    class="flex ml-4 bg-white text-gray-800 mx-auto rounded-lg lg:block hidden border-salesium-blue w-fit"
                    :options="filteredProfessions"
                    textAttribute="name"
                    valueAttribute="id"
                    v-model="filters.selectedProfession"
                ></t-select>
            </span>
        </div>
        <div class="relative flex grid grid-cols-3 mt-4">
            <span v-if="searchOptions.includes('walkins')"
                  class="text-gray-800 lg:block hidden">
                  <t-checkbox name="options" v-model="filters.walkinsWelcome" />
                  Walkins Welcome
            </span>
            <div v-if="searchOptions.includes('premium')" class="flex bg-gray-200 rounded-lg ml-10">
                <div class="inline-flex rounded-lg">
                    <input type="radio" v-model="initiallyPremium" value="premium" id="premium" name="allOrPremium" checked style="visibility:hidden"
                           @change="showOrHidePros" />
                    <label for="premium" class="radio text-center self-center py-2 px-4 rounded-lg cursor-pointer hover:opacity-75">Sponsored Pros</label>
                </div>
                <div class="inline-flex rounded-lg">
                    <input type="radio" v-model="initiallyPremium" value="all" id="all" name="allOrPremium" style="visibility:hidden"
                           @change="showOrHidePros" />
                    <label for="all" class="radio text-center self-center py-2 px-4 rounded-lg cursor-pointer hover:opacity-75">All Pros</label>
                </div>
            </div>
        </div>
        <button
            type="submit"
            class="primary-btn mt-4 px-12"
        >
            Search
        </button>
    </form>
    <form v-else>
                    <span>
                    <input
                        v-if="searchOptions.includes('text')"
                        class="w-full rounded-lg"
                        type="text"
                        placeholder="Search for a Pro"
                        v-model="filters.search_text"
                        @change="applyFilters"
                    />
                    <span>
                            Industry:
                    <t-select
                        v-if="searchOptions.includes('industry')"
                        class="flex ml-10 bg-white text-gray-800 mx-auto rounded-lg lg:block hidden border-salesium-blue w-fit"
                        placeholder="All"
                        :options="industriesData"
                        textAttribute="name"
                        valueAttribute="id"
                        v-model="filters.selectedIndustry"
                        @change="selectIndustry"
                    ></t-select>
                    </span>
                    <t-select
                        v-if="searchOptions.includes('profession')"
                        class="flex bg-white text-gray-800 mx-auto rounded-lg w-1/2 lg:block hidden"
                        placeholder="Profession"
                        :options="filteredProfessions"
                        textAttribute="name"
                        valueAttribute="id"
                        v-model="filters.selectedProfession"
                        @change="applyFilters"
                    ></t-select>
                    </span>
        <span v-if="searchOptions.includes('walkins')">
                        <t-checkbox name="options" v-model="filters.walkinsWelcome" @change="applyFilters" /> Walkins Welcome
                    </span>
        <span v-if="searchOptions.includes('location')">
            <t-select
                          class="flex bg-white text-gray-800 mx-auto rounded-lg w-1/2 lg:block hidden"
                          placeholder="Distance"
                          :options="radiusChoices"
                          textAttribute="name"
                          valueAttribute="id"
                          v-model="filters.selectedRadius"
                          @change="applyFilters"
            ></t-select>
            <input
                          class="w-full rounded-lg"
                          type="text"
                          placeholder="nearby zip"
                          v-model="filters.postal_code"
                          @change="applyFilters"
            />
        </span>
    </form>
    <span class="flex items-left mt-4">
                <div class="bg-gray-200 rounded-lg">

                  <div class="inline-flex rounded-lg">
                    <input type="radio" v-model="filters.sortBy" value="alpha" id="alpha" name="sortOrder" style="visibility: hidden"
                           @change="sortPros"/>
                    <label for="alpha" class="radio text-center self-center py-2 px-4 rounded-lg cursor-pointer hover:opacity-75">A-Z</label><br>
                  </div>
                  <div class="inline-flex rounded-lg" v-if="showDistanceButton">
                    <input type="radio" v-model="filters.sortBy" value="distance" id="distance" name="sortOrder" style="visibility: hidden"
                           @change="sortPros"/>
                    <label for="distance" class="radio text-center self-center py-2 px-4 rounded-lg cursor-pointer hover:opacity-75">Distance</label><br>
                  </div>
                  <div class="inline-flex" v-else>
                    <form @submit.prevent="enterpostalcode">
                        <button type="submit"
                                class="text-center self-center py-2 px-4 rounded-lg hover:opacity-75">
                            Distance
                        </button>
                    </form>
                  </div>
                  <div class="inline-flex rounded-lg" v-if="showRelevanceButton">
                    <input type="radio" v-model="filters.sortBy" value="relevance" id="relevance" name="sortOrder" style="visibility: hidden"
                           @change="sortPros"/>
                    <label for="relevance" class="radio text-center self-center py-2 px-4 rounded-lg cursor-pointer hover:opacity-75">Relevance</label><br>
                  </div>
                  <div class="inline-flex rounded-lg" v-if="showCareScoreButton">
                    <input type="radio" v-model="filters.sortBy" value="carescore" id="care_score" name="sortOrder" style="visibility:hidden"
                           @change="sortPros"/>
                    <label for="care_score" class="radio text-center self-center py-2 px-4 rounded-lg cursor-pointer hover:opacity-75">Care Score</label>
                  </div>
                </div>
            </span>
    </div>
</template>

<script>

export default {
    name: "ProFilter",
    mounted() {
        console.log( "professions: ");
        console.log( this.professions);
        console.log( "initial Sort");
        console.log( this.initialSort);
    },
    data() {
        console.log( 'initial sort: ' + this.initialSort);
        return {
            filters: {
                search_text: "",
                selectedIndustry: "",
                selectedProfession: "",
                selectedRadius: this.initialRadius,
                walkinsWelcome: false,
                postal_code: (this.user && this.user.home_location && this.user.home_location.postal_code)
                               ? this.user.home_location.postal_code
                               : ((this.user && this.user.business_location)
                                    ? this.user.business_location.postal_code
                                    : ""),
                sortBy: this.initialSort,
            },
            members: [],
            filteredProfessions: [{name:"All"}, ...this.professions],
            industriesData: [{name: "All"}, ...this.industries],
            data: null,
            premiumOnly: false,
            searchOptions: [
                "text", "industry",
                //"profession",
                "walkins", "location", "sort"],
            radiusChoices: ["5mi", "10mi", "25mi", "50mi", "200mi", "500mi", "1000mi","5000mi"],
            showDistanceButton: (this.user && this.user.home_location && this.user.home_location.postal_code)
                ? true
                : (this.user && this.user.business_location),
            showRelevanceButton: false,
            showCareScoreButton: false,
        };
    },
    props: [ "user",
        "industries",
        "industry",
        "professions",
        "profession",
        "organization",
//        "searchOptions",
//        "radiusChoices",
        "withSubmit",
        "initiallyPremium",
        "initialRadius",
        "initialSort",
        "pros",
    ],
    methods: {
        applyFilters(){
            this.showRelevanceButton = this.filters.search_text && !this.organization;
            this.showDistanceButton = !!this.filters.postal_code;
            this.$emit('applyFilters', this.filters, true);
        },
        sortPros(){
            console.log( 'sortPros/sortBy: ' + this.filters.sortBy);
            this.$emit( 'sortPros', this.filters.sortBy);
        },
        updatePostalCode(){

        },
        selectIndustry(){
            // down select professions when industry selected
            this.filteredProfessions = [{name: "All"}, ...this.professions.filter( this.matchIndustry)];
            if( !this.withSubmit) {
                this.applyFilters();
            }
        },
//        filterProfessions(){
//            let narrowedProfessions = [];
//            for (const profession in this.professions){
//                if( this.matchIndustry( profession))
//                    narrowedProfessions.push( profession);
//            }
//            return narrowedProfessions;
//        },
        matchIndustry( profession) {
            if( this.selectedIndustry && this.selectedIndustry !== 'all'){
                return this.selectedIndustry === profession.industry_id;
            } else {
                return true; // for no selected industry, back to all
            }
        },
        enterpostalcode(){
          alert('Enter Postal Code and click Search to enable Distance');
        },
//        disableDistance( ) {
//            if( !this.pros || this.pros.length === 0)
//                return true;
//            console.log( this.pros[0]);
//            return !("distance" in this.pros[0]);
//        }
    }
}
</script>

<style scoped>

</style>
